var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', [_c('b-row', [_c('b-col', {
    staticClass: "d-flex justify-content-center m-2",
    attrs: {
      "md": "12"
    }
  }, [_c('button', {
    class: {
      'clicked': _vm.activeButton === 'offers'
    },
    on: {
      "click": function ($event) {
        return _vm.onClickActiveBtn('offers');
      }
    }
  }, [_vm._v(" Available Offers ")]), _c('button', {
    class: {
      'clicked': _vm.activeButton === 'packages'
    },
    on: {
      "click": function ($event) {
        return _vm.onClickActiveBtn('packages');
      }
    }
  }, [_vm._v(" All Packages ")])])], 1), _c('b-row', _vm._l(_vm.dummyData, function (item, index) {
    return _c('b-col', {
      key: index,
      attrs: {
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "card text-center"
    }, [_c('h3', {
      staticClass: "card-header"
    }, [_vm._v("Basic Package")]), _c('div', {
      staticClass: "card-body"
    }, [_c('h3', {
      staticClass: "card-title mt-1"
    }, [_vm._v("₹ 2200")]), _c('h3', {
      staticClass: "card-text"
    }, [_vm._v("Preventive Health Checkup")]), _c('br'), _c('p', {
      staticClass: "card-text"
    }, [_c('small', {}, [_vm._v(" Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur cupiditate non corporis cumque quis saepe ")])]), _c('b-icon', {
      staticClass: "right-icon",
      attrs: {
        "icon": "arrow-right-circle"
      },
      on: {
        "click": _vm.onArrowIconClick
      }
    })], 1)])]);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }